import http from './person-api.http';
import { PersonService } from './person-api.types';

export async function whoAmI(userId: number | string) {
  const res = await http.get<PersonService.GetWhoAmIResponse>(`/user/${userId}`);
  return res.data;
}

export default {
  whoAmI,
};
